import { initializeApp } from 'firebase/app';
import { getMessaging, onMessage } from 'firebase/messaging';

let messaging: any;

try {
    const firebaseApp = initializeApp({
        apiKey: 'AIzaSyBQBp7FVJhHINauyiLaQxqWpgDSPiOa1OQ',
        authDomain: 'starfruit-942a5.firebaseapp.com',
        projectId: 'starfruit-942a5',
        storageBucket: 'starfruit-942a5.appspot.com',
        messagingSenderId: '591906872695',
        appId: '1:591906872695:web:26366fef0de96470651572',
    });

    messaging = getMessaging(firebaseApp);

    onMessage(messaging, (payload) => {
        if (payload) {
            console.log('Message received. ', payload);
        }
    });
} catch (err) {
    console.error('Failed to initialize Firebase Messaging', err);
}

export default messaging;
